<div id="wrapper">
	<div id="left">
		<input
			type="text"
			ngxDaterangepickerMd
			class="date-range-picker"
			readonly
			[(ngModel)]="selected"
			placeholder="Choose date range"
			[showDropdowns]="true"
			[isInvalidDate]="isInvalidDate"
			[locale]="isR9 ? { format: 'MM/DD/YY' } : { format: 'MM/DD/YYYY' }"
			(datesUpdated)="applyDate($event)"
			showCancel="true"
			(click)="showCalendar($event)"
			[maxDate]="maxDate"
			[minDate]="minDate"
			(blur)="hideCalendar($event)"
		/>
		<span id="errorMessage" class="tooltipText"></span>
	</div>
	<div id="right">
		<span
			class="fa ngx-daterangepicker-action"
			[ngClass]="{ 'fa-angle-down': !isActive, 'fa-angle-up': isActive }"
			(click)="toggleCalendar($event)"
		></span>
		<span class="info-icon-wrapper" style="margin-left: 8px; display: inline-block; position: relative">
			<svg
				class="info-icon-container"
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				style="vertical-align: middle; cursor: pointer"
			>
				<path
					d="M8.66667 10.6667H8V8H7.33333M8 5.33333H8.00667M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
					stroke="#393939"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<div class="custom-tooltip">{{ tooltipText }}</div>
		</span>
	</div>
</div>
